module.exports = "class MyComponent extends React.Component {\n  render() {\n    return <h1>Hello {this.props.name}</h1>;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/class.example
// module id = 1524
// module chunks = 0